export let accordion = function () {
    $("button.accordion").click(function () {
        $(this).siblings().slideToggle();
        $(this).toggleClass("open");
        $('.top-level').toggleClass("open");

        let attr = $(this).attr('aria-expanded');

        if (attr == 'false') {
            attr = 'true';
        } else {
            attr = 'false';
        }

        $(this).attr('aria-expanded', attr);
    });

}